import styled, { css } from 'styled-components'
import { fontSize, spacing } from 'themes/styles/dimensions'
import { fieldDisplayStyle, backgroundColorStyle, borderColorStyle } from './FormInput.styles'

const selectArrowStyle = props =>
  props.disabled || props.noArrow
    ? null
    : css`
        &:after {
          content: "";
          position: absolute;
          z-index: 2;
          right: 8px;
          bottom: ${props => props.narrow ? '25px' : '30px'};
          border-top: 6px solid #dddfdf;
          border-left: 6px solid transparent;
          border-right :6px solid transparent;
          pointer-events: none;
        }
      `

export const SelectFieldWrapper = styled.div`
  ${fieldDisplayStyle};
  ${selectArrowStyle}
`

export const StyledSelect = styled.select`
  width: ${props => props.inputWidth || '100%'};
  padding: ${props => props.narrow ? '4px 8px' : '8px'};
  margin-bottom: 2px;
  font-size: ${props => props.textSize || fontSize.milli};
  font-family: 'Libre Baskerville', Baskerville, 'Baskerville Old Face',
    'Hoefler Text', Garamond, 'Times New Roman', serif;
  ${backgroundColorStyle}
  color: ${props => props.color || '#000'};
  border-radius: 8px;
  border: 2px solid;
  ${borderColorStyle};
  opacity: ${props => props.opacity};

  -webkit-appearance: none;
  -moz-appearance: none;
`
